import {
  AutoComplete,
  Avatar,
  Dropdown,
  Input,
  Layout,
  Menu,
  Select,
  Space,
  Tooltip,
} from 'antd'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useReactRouter from 'use-react-router'
import { TypographyText } from '..'
import { ReactComponent as ServerLogs } from '../../assets/icons/activity.svg'
import { ReactComponent as Bellicon } from '../../assets/icons/bell-icon.svg'
import { ReactComponent as EyeOutlined } from '../../assets/icons/changepassword.svg'
import { ReactComponent as Dropicon } from '../../assets/icons/drop-arrow.svg'
import { ReactComponent as EditProfile } from '../../assets/icons/editprofile.svg'
import { ReactComponent as ProjectsIcon } from '../../assets/icons/jobIcon.svg'
import { ReactComponent as LogoutIcon } from '../../assets/icons/log-out.svg'
import { ReactComponent as Logo } from '../../assets/icons/page-logo.svg'
import { ReactComponent as SearchIcon } from '../../assets/icons/searchicon.svg'
import { ReactComponent as SettingIcon } from '../../assets/icons/setting.svg'
import { ReactComponent as Holiday } from '../../assets/icons/holiday.svg'
import { ReactComponent as Identity } from '../../assets/icons/identity.svg'
import { images } from '../../config/images'
import { projectDetailsSelector } from '../../redux/reducer/getProjectsByIdSlice'
import { AuthContext } from '../../store/auth'
import {
  headerItemLabels,
  noHeaderOptions,
  UserRoles,
} from '../../utils/constants/constant'
import {
  getHeaderOptions,
  validateRequiredFieldsForPredictions,
} from '../../utils/helperFunctions/helperFunctions'
import Button from '../Button/Button'
import ChangePassword from '../ChangePasswordModule/ChangePasswordModule'
import EditProfileModule from '../EditProfileModule/EditProfileModule'
import CustomizeModal from '../Modal/Modal'
import ReceivedInvoice from '../ReceivedInvoice/ReceivedInvoice'
import SearchBar from '../SearchBar/SearchBar'
import './Header.scss'
import GroupSelectField from '../GroupSelectFIeld/GroupSelectField'
import { predictionDetailsSelector } from '../../redux/reducer/getPredictionsByIdSlice'

const { Header } = Layout

function AppHeader() {
  const [receivedInvoice, setReceiveInvoice] = useState(false)
  const [showHeaderOptions, setShowHeaderOptions] = useState(true)
  const [editProfile, setEditProfile] = useState(false)
  const [changePassword, setChangePassword] = useState(false)
  const [ShowsearchField, setShowSearchField] = useState(false)
  const [options, setOptions] = useState([])
  const { projectId } = useSelector((state) => state.projectId)
  const { userRole, logout } = useContext(AuthContext)
  // ROLE_PM only gets Project Details / Developers / Delivery Progress /
  // Estimation History in this tab bar -- Rate Details, Prediction &
  // Invoices, Client Details and Notes stay Admin/CSM/Accountant only.
  const isPM = userRole === UserRoles.PM
  const { projectDetails } = useSelector(projectDetailsSelector)
  const { predictionDetails } = useSelector(predictionDetailsSelector)
  const { missingFields, validationFields } =
    validateRequiredFieldsForPredictions(projectDetails)
  const isMissingBillingConfiguration = useMemo(
    () => projectDetails?.projectConfigurationDetails?.length === 0,
    [projectDetails]
  )
  const isEmptyAssocaitedList = useMemo(
    () =>
      predictionDetails?.associatedInvoiceList?.length === 0 ||
      predictionDetails?.associatedPredictionList?.length === 0,
    [predictionDetails]
  )
  const { location } = useReactRouter()
  const searchParams = new URLSearchParams(location.search)
  const headerSelectedItem =
    location.state?.headerSelectedItem || searchParams.get('headerSelectedItem')
  const [items] = useState([
    'Omneship',
    'Invoicing System',
    'Hopscoach',
    'TagB',
    'Innovation',
    'Parking',
    'jakes app',
    'Fisher Shipping',
    'Nas',
    'Prev app',
  ])
  const getTooltipTitle = () => {
    const messages = []

    if (missingFields.length > 0) {
      messages.push(
        `Please add ${missingFields.join(
          ', '
        )} in project to add prediction or invoice`
      )
    }

    if (isMissingBillingConfiguration) {
      messages.push(
        `Please configure billing details to add prediction or invoice`
      )
    }

    return messages.length > 0 ? messages.join('. ') : null
  }

  const commonHeaders = [
    {
      label: headerItemLabels.PROJECT_DETAILS,
      path: `/projectdetails/${projectId}`,
      hide: isPM,
      key: headerItemLabels.PROJECT_DETAILS,
    },
    {
      label: headerItemLabels.RATE_DETAILS,
      path: `/ratedetails/${projectId}`,
      hide: isPM,
      key: headerItemLabels.RATE_DETAILS,
    },
    {
      label: headerItemLabels.LEAVE_BALANCE,
      path: `/developers/${projectId}`,
      hide: false,
      key: headerItemLabels.LEAVE_BALANCE,
    },

    {
      label:
        isEmptyAssocaitedList &&
        Object.values(validationFields).some(
          (val) => val === '-' || val === null
        ) ? (
          <Tooltip title={getTooltipTitle()}>
            <TypographyText
              text={headerItemLabels.PREDICTION_AND_PENDING_INVOICES}
              disabled={true}
            />
          </Tooltip>
        ) : (
          headerItemLabels.PREDICTION_AND_PENDING_INVOICES
        ),

      path: `/predictiondetails/${projectId}`,
      hide: isPM,
      key: headerItemLabels.PREDICTION_AND_PENDING_INVOICES,
      disabled:
        isEmptyAssocaitedList &&
        Object.values(validationFields).some(
          (val) => val === '-' || val === null
        ),
    },
    {
      label: headerItemLabels.CLIENT_DETAILS,
      path: `/clientdetails/${projectId}`,
      hide: isPM,
      key: headerItemLabels.CLIENT_DETAILS,
    },
    {
      label: headerItemLabels.PROJECT_NOTES,
      path: `/projectnotes/${projectId}`,
      hide: isPM,
      key: headerItemLabels.PROJECT_NOTES,
    },
    {
      label: headerItemLabels.DELIVERY_PROGRESS,
      path: `/deliveryprogress/${projectId}`,
      hide: false,
      key: headerItemLabels.DELIVERY_PROGRESS,
    },
    {
      label: headerItemLabels.ESTIMATION_HISTORY,
      path: `/estimationhistory/${projectId}`,
      hide: false,
      key: headerItemLabels.ESTIMATION_HISTORY,
    },
  ].filter((header) => !header.hide)

  // Fall back to matching the current pathname against `commonHeaders` when
  // nothing explicitly set `headerSelectedItem` (state or query param) --
  // e.g. landing on a project sub-page via the Sidebar's "Project Delivery"
  // row click or an Anomaly Dashboard action link never sets that state, so
  // without this fallback the header tab bar highlighted nothing (or the
  // wrong tab) for those entry points. Explicit overrides from existing call
  // sites across the app still win when present.
  const pathname = location?.pathname
  const matchedHeaderKey = commonHeaders.find((header) =>
    pathname?.startsWith(header.path)
  )?.key
  const resolvedHeaderSelectedItem = headerSelectedItem || matchedHeaderKey

  const getRandomInt = (max, min = 0) => {
    const range = max - min + 1
    const array = new Uint32Array(1)
    window.crypto.getRandomValues(array)
    return min + (array[0] % range)
  }

  const searchResult = (query) =>
    new Array(getRandomInt(5))
      .join('.')
      .split('.')
      .map((_, idx) => {
        const category = `${query}${idx}`
        return {
          value: category,
          label: (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>{query}</span>
              <span>{getRandomInt(200, 100)} results</span>
            </div>
          ),
        }
      })
  const handleSearch = (value) => {
    setOptions(value ? searchResult(value) : [])
  }
  const history = useHistory()

  const openReceivedInvoiceModule = () => {
    setReceiveInvoice(!receivedInvoice)
  }
  const openChangePasswordModule = () => {
    setChangePassword(!changePassword)
  }
  const openEditProfileMOdule = () => {
    setEditProfile(!editProfile)
  }
  const openSearchModule = () => {
    setShowSearchField(true)
  }
  const onClose = () => {
    setReceiveInvoice(false)
    setEditProfile(false)
    setChangePassword(false)
  }

  const onMenuItemClick = (event) => {
    const path = event.item.props.path
    const key = event.key
    const currentState = history.location.state || {}

    // Only block predictiondetails if missingFields is not empty
    if (path.includes('/predictiondetails') && missingFields.length > 0) return

    history.push({
      pathname: path,
      state: {
        ...currentState,
        headerSelectedItem: key,
      },
    })
  }

  const menu = (
    <Menu
      items={[
        {
          label: (
            <div onClick={openEditProfileMOdule} className="logout-menu-item">
              <span className="dropdown-icons">
                <EditProfile />
              </span>
              Edit Profile
            </div>
          ),
          key: '0',
        },
        {
          label: (
            <div
              onClick={openChangePasswordModule}
              className="logout-menu-item"
            >
              <span className="dropdown-icons">
                <EyeOutlined />
              </span>
              Change Password
            </div>
          ),
          key: '1',
        },
        // ROLE_PM has no accessible Settings routes (see pmAccessibleRoutesArray
        // in helperFunctions.js's getCurrentRoleRoutes) -- the menu entry itself
        // must stay hidden for PM rather than just relying on route protection.
        !isPM && {
          label: (
            <div className="logout-menu-item">
              <span className="dropdown-icons">
                <SettingIcon />
              </span>
              Setting
            </div>
          ),
          key: '2',
          children:
            userRole === 'ROLE_ADMIN'
              ? [
                  {
                    key: 's1',
                    label: (
                      <div
                        onClick={() => history.push('/settings/jobScheduler')}
                        className="logout-menu-item"
                      >
                        <span className="dropdown-icons">
                          <ProjectsIcon />
                        </span>
                        Jobs
                      </div>
                    ),
                  },
                  {
                    key: 's2',
                    label: (
                      <div
                        onClick={() => history.push('/settings/serverLogs')}
                        className="logout-menu-item"
                      >
                        <span className="dropdown-icons">
                          <ServerLogs />
                        </span>
                        Server Logs
                      </div>
                    ),
                  },
                  {
                    key: 's3',
                    label: (
                      <div
                        onClick={() => history.push('/settings/holidays')}
                        className="logout-menu-item"
                      >
                        <span className="dropdown-icons">
                          <Holiday />
                        </span>
                        Holidays
                      </div>
                    ),
                  },
                  {
                    key: 's4',
                    label: (
                      <div
                        onClick={() =>
                          history.push('/settings/identityProvider')
                        }
                        className="logout-menu-item"
                      >
                        <span className="dropdown-icons">
                          <Identity />
                        </span>
                        Identity Provider
                      </div>
                    ),
                  },
                  {
                    key: 's5',
                    // Item-level onClick (not the label div) so rc-menu also
                    // fires it on Enter for keyboard users.
                    onClick: () => history.push('/settings/deliverySettings'),
                    label: (
                      <div className="logout-menu-item">
                        <span className="dropdown-icons">
                          <SettingIcon />
                        </span>
                        Delivery Settings
                      </div>
                    ),
                  },
                ]
              : [
                  {
                    key: 's2',
                    label: (
                      <div
                        onClick={() => history.push('/settings/serverLogs')}
                        className="logout-menu-item"
                      >
                        <span className="dropdown-icons">
                          <ServerLogs />
                        </span>
                        Server Logs
                      </div>
                    ),
                  },
                ],
        },
        {
          label: (
            <div onClick={logout} className="logout-menu-item">
              <span className="dropdown-icons">
                <LogoutIcon />
              </span>
              Log Out
            </div>
          ),
          key: '3',
        },
      ].filter(Boolean)}
    />
  )
  useEffect(() => {
    if (
      noHeaderOptions.includes(location?.pathname) ||
      location?.pathname.includes('companydetails') ||
      location?.pathname.includes('assignedprojects') ||
      location?.pathname.includes('techstack') ||
      location?.pathname.includes('/salesPersons/incentive')
    ) {
      setShowHeaderOptions(false)
    }
  }, [location.pathname])

  return (
    <Layout className="header-wrap">
      <Header className="header">
        <div className="page-header">
          <div className="logo">
            <a href="/">
              <Logo />
            </a>
          </div>
          <div className="page-nav">
            <Menu
              onSelect={onMenuItemClick}
              theme="light"
              mode="horizontal"
              defaultSelectedKeys={[
                resolvedHeaderSelectedItem || headerItemLabels.PROJECT_DETAILS,
              ]}
              items={showHeaderOptions ? getHeaderOptions(commonHeaders) : null}
              className="project-detail-header"
            />
          </div>
          <div className="page-action">
            <ul className="list-items">
              {userRole !== UserRoles.PM && (
                <li>
                  <Button
                    onClick={openReceivedInvoiceModule}
                    danger
                    label={'Search Invoices'}
                    className="generate-invoice-btn"
                  />
                </li>
              )}
              {userRole === 'ROLE_ADMIN' && (
                <li>
                  <GroupSelectField />
                </li>
              )}
              <li>
                <Button
                  className="search-btn"
                  aria-label="Open global search"
                  onClick={openSearchModule}
                  icon={<SearchIcon aria-hidden="true" />}
                />
              </li>
              <li className="bell-icon">
                <Bellicon />
                <span className="notifi-dot"></span>
              </li>
              <li>
                <Dropdown
                  overlay={menu}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  trigger={['click']}
                  autoFocus={true}
                >
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <Space>
                      <div className="profile-icon">
                        <Avatar src={images.profile} size={40} />
                      </div>
                      <div className="drop-icon">
                        <Dropicon />
                      </div>
                    </Space>
                  </a>
                </Dropdown>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ReceivedInvoice open={receivedInvoice} onClose={onClose} />
      <ChangePassword open={changePassword} onClose={onClose} />
      <EditProfileModule open={editProfile} onClose={onClose} />
      <CustomizeModal
        open={ShowsearchField}
        setShowSearchField={setShowSearchField}
        footer={null}
        size={1000}
        closable={true}
      >
        <Input.Group compact className="padding-10">
          <AutoComplete
            dropdownMatchSelectWidth={1000}
            options={options}
            onSearch={handleSearch}
            popupClassName="search-menu"
            className="search-popup-text"
          >
            <Input.Search placeholder="Type here to start your search" />
          </AutoComplete>
          <Select
            style={{ width: 300 }}
            dropdownMatchSelectWidth={250}
            className="search-project-bar"
            placeholder="All Project"
            popupClassName="select-menu"
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            dropdownRender={(menu) => (
              <>
                <SearchBar placeholder={'Search'} searchP="search-project" />
                {menu}
              </>
            )}
          >
            <Select.Option key={'all-projects'}>All Project</Select.Option>
            {items.map((item) => (
              <Select.Option key={item}>{item}</Select.Option>
            ))}
          </Select>
        </Input.Group>
      </CustomizeModal>
    </Layout>
  )
}
export default AppHeader
